import React, { useEffect, useState } from 'react';
import style from './chart.module.scss';
import { Avatar, List, message } from 'antd';
import VirtualList from 'rc-virtual-list';
import EventBus from '@/modules/pain-points/hooks/eventBus';
import NoData from './noData.jsx';
import ClickDot from './clickDot.jsx';

const App = () => {
  const [isDetailLoading, setIsDetailLoading] = useState(false);
  let [data, setData] = useState({ id: 0, title: 'Full description of the need Full description of the need', list: [
    {key:0,value:'Consumer Verbatim'},
    {key:1,value:'Consumer Verbatim'},
    {key:2,value:'Consumer Verbatim'},
    {key:3,value:'Consumer Verbatim'},
    {key:4,value:'Consumer Verbatim'},
    {key:5,value:'Consumer Verbatim'},
    {key:6,value:'Consumer Verbatim'},
    {key:7,value:'Consumer Verbatim'},
    {key:8,value:'Consumer Verbatim'},
    {key:9,value:'Consumer Verbatim'},
    {key:10,value:'Consumer Verbatim'},
    {key:11,value:'Consumer Verbatim'},
  ] });

  useEffect(() => {
    //挂载
    // EventBus.addEventListener('painPointDetailEvent', handlePainPointDetailEvent);
    EventBus.addEventListener('painPointVerbatimsEvent', handlePainPointVerbatimsEvent);
    return (() => {
      //卸载
      // EventBus.removeEventListener('painPointDetailEvent', handlePainPointDetailEvent);
      EventBus.removeEventListener('painPointVerbatimsEvent', handlePainPointVerbatimsEvent);
    });
  }, []);
  useEffect(() => {
    EventBus.addEventListener('isDetailLoading', handleIsDetailLoading);
    return (() => {
      EventBus.removeEventListener('isDetailLoading', handleIsDetailLoading);
    });
  }, []);
  const handleIsDetailLoading = (e) => {
    setIsDetailLoading(e.detail);
  };  

  const handlePainPointDetailEvent = e => {
    // 等待数据
    // let list = e.detail.list.map((v, k) => ({ key: k, value: v }));
    // let dataC = ({ title: e.detail.title, list: list });
    // setData(dataC);
    // console.log('dataC接收到传值啦！~~~~~~');
  };

  const handlePainPointVerbatimsEvent = e => {
    console.log('handlePainPointVerbatimsEvent接收到传值啦！~~~~~~', e);
    if(e.detail.length){
      let list = e.detail.map((i) => ({ key: i.id, value: i.verbatim }));
      let dataC = ({ title: e.detail[0].revised_statement, list: list });
      setData(dataC);
    }else{
      setData({ id: 0, title: 'Full description of the need Full description of the need', list: [
        {key:0,value:'Consumer Verbatim'},
        {key:1,value:'Consumer Verbatim'},
        {key:2,value:'Consumer Verbatim'},
        {key:3,value:'Consumer Verbatim'},
        {key:4,value:'Consumer Verbatim'},
        {key:5,value:'Consumer Verbatim'},
        {key:6,value:'Consumer Verbatim'},
        {key:7,value:'Consumer Verbatim'},
        {key:8,value:'Consumer Verbatim'},
        {key:9,value:'Consumer Verbatim'},
        {key:10,value:'Consumer Verbatim'},
        {key:11,value:'Consumer Verbatim'},
      ] });
    }
  };



  let ContainerHeight = 350;

  const onScroll = (e) => {
    if (Math.abs(e.currentTarget.scrollHeight - e.currentTarget.scrollTop - ContainerHeight) <= 1) {
    }
  };
  return <>
  <div style={{ padding: '0 20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between',position: 'relative' }}>
        {isDetailLoading && (
          <div className={style.detailLoadingOverlay}>
            <div className={style.spinner}></div>
            <div className={style.loadingText}>Loading...</div>
          </div>
        )}
        {data.id === 0 && (
          <div className={style.clickDotOverlay}>
            <ClickDot/>
          </div>
        )}
          <div style={{ padding: '0 10px 10px 0', color: '#b9b9b9' ,fontSize:'0.9vw'}}>{data.title}</div>
          <List
            split={false} style={{marginTop:'10px'}}
          >
            <VirtualList
              data={data.list}
              height={ContainerHeight}
              itemHeight={40}
              itemKey="key"
              onScroll={onScroll}
              styles={{ verticalScrollBarThumb: { background: '#02661c' } }}
            >
              {(item) => (
                <List.Item style={{ color: 'rgb(72,158,64)',fontSize:'0.8vw',lineHeight:'0.8vw'}}>{item.value}</List.Item>
              )}
            </VirtualList>
          </List>
        </div>
  </>;

};

export default App;